import styles from "./About.module.css";

function AboutPage() {
  return (
    <>
      <section className={styles.section}>
        <h2>Your friendly neighborhood Beer Guy!</h2>
        <div className={styles.flex}>
          <div className={styles.half}>
            <p>
              The Beer Guy is proud to offer draft beer equipment, repair, and
              services to Edmonton, Alberta, and to all of western Canada! With
              over 12 years of experience in the bar & draft beer maintenance
              industry and related trades, we are committed to reducing costs
              and maximizing the profitability of draft beer systems. We do this
              by optimizing beer systems to minimize waste, both during cleaning
              and daily operation of the system. So why do you need a Beer Guy
              and what seperates our service from others? Well, first we offer a
              Beer Guy Guarantee! What this means for you is:
            </p>
            <ul>
              <li>
                Professionalism and customer service will always be first
                priority! Always happy to help with a smile, you'll receive
                honest and knowledgeful service 100% of the time. No hidden
                bills or unprofessional demeanor here.
              </li>
              <li>
                We offer the most reliable, effective, and affordable draft beer
                line cleaning, service, and installations in Alberta.
              </li>
              <li>
                You have our commitment to save you money & maximize profits,
                fix any issues that arise, educate you on your system and best
                practices, and to extend the life of your system overall.
              </li>
            </ul>
            <p>
              By choosing The Beer Guy Draft Services, you are choosing to have
              a reliable technician on hand with experience servicing 100+
              monthly clients, professional and certified training on
              installations and service, and the friendliness and willingness to
              help you with any situation at the lowest cost possible. There is
              no question, if you're looking for the best, you've found it!
            </p>
          </div>
          <div className={styles.aboutpic}></div>
        </div>
        <div className={styles.flex}>
          <div className={styles.half}>
            <div className={styles.aboutpic2}></div>
          </div>
          <div className={styles.half}>
            <h3>The Guy behind the beer</h3>
            <p>
              Meet your Beer Guy: Justin! Born and raised in Edmonton, Alberta,
              and with strong family ties spread throughout British Columbia,
              I'm proud to call western Canada home. Me & my wife were married
              last year in Nakusp, BC and have a small furry family consisting
              of one pup and two cats. Hobbies include board games, logic
              puzzles, web design, fantasy hockey, and reading. I've worked in
              the bar & hospitality industry for over 15 years, as well as 4
              years in the trades as a plumber and general maintenance. I have a
              passion for knowledge and continuous learning, which lead me to
              NAIT where I studied web design, business analytics, and marketing
              for 3 years and graduated with honours. Graduating out of school I
              knew I wanted to revisit my love for the beer industry in a
              different direction. I was hired by a company as a Beer Line
              Technician where I've spent the last two years handling 100+
              cleaning clients monthly, assisting with installations, and
              completing service calls of many varieties. As time went on I knew
              I wanted to continue my personal growth and deliver the quality of
              service that I would like, which naturaly lead to the decision to
              pursue my own business! Summer of 2023 I packed my bags and headed
              down to California to take part in Micromatic's advanced
              installers training course which gave me extra knowledge I know
              will help in providing my clients the best service. I'm excited to
              bring my top notch level of service to all my clients and to have
              us all grow and prosper together!
            </p>
          </div>
        </div>
        <div className={styles.flex}>
          <div className={styles.half}>
            <div className={styles.aboutpic4}></div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutPage;
